import { Grouping } from "@devexpress/dx-react-grid";
import { InvoiceListState, UpdateInvoicesActionPayload } from "./rootReducerTypes";
import {
    InvoiceListActionTypes, UPDATE_ORDER_TYPE, UPDATE_INVOICES, REQUEST_ERROR, FETCH_INIT, SET_CURRENT_PAGE, UPDATE_QUERY, SetPageSizeAction, SET_PAGE_SIZE, UPDATE_SHOW_HISTORICAL, UPDATE_ORDER_INVOICE_STATUS, UpdateSortByAction, UPDATE_SORTBY, UPDATE_SEARCH_INVOICES, UpdateSearchInvoicesAction, ChangeGroupingAction, CHANGE_GROUPING, SetExpandedGroupsAction, SET_EXPANDED_GROUPS,
    UpdateInvoicesAction
    , RequestErrorAction
    , FetchInitAction
    , SetCurrentPageAction
    , UpdateQueryAction
    , UpdateShowHistoricalAction
    , UpdateOrderInvoiceStatusAction
    , UpdateOrderTypeAction,
    UpdateDateTypeAction,
    UPDATE_DATE_TYPE
} from './invoiceListActionsAndReducerTypes';

// #region actions
export function updateInvoices(updateInvoicesActionPayload: UpdateInvoicesActionPayload): UpdateInvoicesAction {
    return {
        type: UPDATE_INVOICES,
        updateInvoicesActionPayload,
    };
}

export function requestError(): RequestErrorAction {
    return {
        type: REQUEST_ERROR,
    };
}
export function fetchInit(): FetchInitAction {
    return {
        type: FETCH_INIT,
    };
}
export function setCurrentPage(currentPage: number): SetCurrentPageAction {
    return {
        type: SET_CURRENT_PAGE,
        currentPage
    };
}
export function setPageSize(pageSize: number): SetPageSizeAction {
    return {
        type: SET_PAGE_SIZE,
        pageSize
    };
}
export function updateQuery(lastQuery: string): UpdateQueryAction {
    return {
        type: UPDATE_QUERY,
        lastQuery
    };
}

export function updateShowHistorical(showHistorical: boolean): UpdateShowHistoricalAction {
    return {
        type: UPDATE_SHOW_HISTORICAL,
        showHistorical
    };
}

export function updateOrderInvoiceStatus(orderInvoiceStatus : any): UpdateOrderInvoiceStatusAction {
    return {
        type: UPDATE_ORDER_INVOICE_STATUS,
        orderInvoiceStatus
    };
}

export function updateOrderType(orderType : any): UpdateOrderTypeAction {
    return {
        type: UPDATE_ORDER_TYPE,
        orderType
    };
}

export function updateDateType(dateType : any): UpdateDateTypeAction {
    return {
        type: UPDATE_DATE_TYPE,
        dateType
    };
}

export function updateSortBy(payload: string): UpdateSortByAction {
    return {
        type: UPDATE_SORTBY,
        sortBy: payload
    };
}

export function updateSearchInvoices(payload: string): UpdateSearchInvoicesAction {
    return {
        type: UPDATE_SEARCH_INVOICES,
        searchText: payload
    };
}

export function changeGrouping(payload: Grouping[]): ChangeGroupingAction {
    return {
        type: CHANGE_GROUPING,
        grouping: payload
    };
}

export function setExpandedGroups(payload: string[]): SetExpandedGroupsAction {
    return {
        type: SET_EXPANDED_GROUPS,
        expandedGroups: payload
    };
}

// #end region actions

export default function invoiceListReducer(state: InvoiceListState = initialState, action: InvoiceListActionTypes): InvoiceListState {
    switch (action.type) {
        case 'UPDATE_INVOICES':
            return {
                ...state,
                invoices: action.updateInvoicesActionPayload.invoices,
                totalCount: action.updateInvoicesActionPayload.totalCount,
                totalGroupCount: action.updateInvoicesActionPayload.totalGroupCount ? action.updateInvoicesActionPayload.totalGroupCount : state.totalGroupCount,
                skip: action.updateInvoicesActionPayload.skip ? action.updateInvoicesActionPayload.skip : state.skip,
                groupChildrenSkip: action.updateInvoicesActionPayload.groupChildrenSkip ? action.updateInvoicesActionPayload.groupChildrenSkip : state.groupChildrenSkip,
                loading: false,
                tempGrouping: null,
                tempExpandedGroups: null,
            };
        case 'REQUEST_ERROR':
            return {
                ...state,
                loading: false,
            };
        case 'FETCH_INIT':
            return {
                ...state,
                loading: true,
            };
        case 'SET_CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.currentPage,
                skip: action.currentPage * state.pageSize,
                groupChildrenSkip: state.expandedGroups.length > 0 ? action.currentPage * state.pageSize : 0
            };
        case 'UPDATE_QUERY':
            return {
                ...state,
                lastQuery: action.lastQuery,
            };
        case 'SET_PAGE_SIZE':
            return {
                ...state,
                pageSize: action.pageSize,
            };
        case 'UPDATE_SHOW_HISTORICAL':
            return {
                ...state,
                showHisorical: action.showHistorical,
            };
        case 'UPDATE_ORDER_INVOICE_STATUS':
            return {
                ...state,
                orderInvoiceStatus: action.orderInvoiceStatus
            };
        case 'UPDATE_ORDER_TYPE':
            return {
                ...state,
                orderType: action.orderType
            };
        case 'UPDATE_DATE_TYPE':
            return {
                ...state,
                dateType: action.dateType
            };
        case 'UPDATE_SORTBY':
            return {
                ...state,
                sortBy: action.sortBy,
            };
        case 'UPDATE_SEARCH_INVOICES':
            return {
                ...state,
                searchText: action.searchText,
            };
        case 'CHANGE_GROUPING':
            return {
                ...state,
                grouping: action.grouping,
                tempGrouping: state.tempGrouping === null ? state.grouping : state.tempGrouping,
                tempExpandedGroups: state.expandedGroups,
            };
        case 'SET_EXPANDED_GROUPS':
            return {
                ...state,
                expandedGroups: action.expandedGroups,
                totalCount: action.expandedGroups.length === 0 && state.grouping.length > 0 ? state.totalGroupCount : state.totalCount,
                groupChildrenSkip: 0
            };
        default:
            return state;
    }
}

export const initialState: InvoiceListState = {
    invoices: [],
    skip: 0,
    totalCount: 0,
    totalGroupCount: 0,
    loading: false,
    lastQuery: '',
    currentPage: 0,
    pageSize: 50,
    showHisorical: false,
    snackBar: { isShow: false, message: '', severity: undefined },
    sortBy: '',
    searchText: '',
    grouping: [],
    expandedGroups: [],
    tempGrouping: null,
    tempExpandedGroups: null,
    groupChildrenSkip: 0,
    orderInvoiceStatus: null,
    orderType: null,
    dateType: 1
};